import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  getCompanies as getCompaniesApi,
  addNewCompany as addNewCompanyApi,
  updateCompany as updateCompanyApi,
  deleteCompany as deleteCompanyApi,
} from "../../helpers/realbackend_helper";

export const getCompanies = createAsyncThunk(
  "company/getCompanies",
  async () => {
    try {
      const response = await getCompaniesApi();
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const addNewCompany = createAsyncThunk(
  "company/addNewCompany",
  async (company) => {
    try {
      const response = addNewCompanyApi(company);
      toast.success("Шинэ компаний мэдээллийг амжилттай нэмлээ", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Шинэ компаний мэдээллийг нэмэхэд алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const updateCompany = createAsyncThunk(
  "company/updateCompany",
  async (company) => {
    try {
      const response = updateCompanyApi(company);
      toast.success("Компаний мэдээллийг амжилттай засварлалаа", {
        autoClose: 3000,
      });
      return response;
    } catch (error) {
      toast.error("Компаний мэдээллийг засварлахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const deleteCompany = createAsyncThunk(
  "company/deleteCompany",
  async (company) => {
    try {
      const response = deleteCompanyApi(company);
      toast.success("Компаний мэдээллийг амжилттай устгалаа", {
        autoClose: 3000,
      });
      return { company, ...response };
    } catch (error) {
      toast.error("Компаний мэдээллийг устгахад алдаа гарлаа!", {
        autoClose: 3000,
      });
      return error;
    }
  }
);
